import { create } from 'zustand';

import { DISTRIBUTOR, ENV } from '@autopass-web/domain';

import { repository } from './app-loader';
import { isFromPromotionBoard, sortingPromotionsByDate } from './helper';

const devFakePromotionQueryList = [
  {
    fakePromotionId: '7a8b37c0-642c-489a-8fed-5930118ba6dc',
    relatePromotion: [
      {
        type: 'RefuelingPromotion',
        id: '1d31d1e5-cd73-43d4-a0ff-3f74e74fd31f',
      },
      {
        type: 'ParkingPromotion',
        id: 'b1855279-e2bc-4ec1-a74c-343c8505779d',
      },
    ],
  },
  {
    fakePromotionId: 'd0be4134-d451-4c93-8f4a-79f760e5ae7f',
    relatePromotion: [
      {
        type: 'ParkingPromotion',
        id: '5067bb40-63af-48ff-95d3-9c4b740d3452',
      },
    ],
  },
  {
    fakePromotionId: '18b02fea-a076-4e0e-9082-d6751914d088',
    relatePromotion: [
      {
        type: 'RefuelingPromotion',
        id: 'eddc2f0f-ea1e-4880-9763-b1f50df0aa01',
      },
      {
        type: 'ParkingPromotion',
        id: '9bb77ed1-207d-4b44-acb5-6ba676e92002',
      },
    ],
  },
  {
    fakePromotionId: '9b2e3d7f-e047-46d4-b12f-83d7d01912d4',
    relatePromotion: [
      {
        type: 'ParkingPromotion',
        id: '0939f002-e74c-4e42-adcf-b7d2929f5ecb',
      },
    ],
  },
  // 2024-07-03
  {
    fakePromotionId: '6e9b0afc-c829-42fd-9625-5288054d42b2',
    relatePromotion: [
      {
        type: 'RefuelingPromotion',
        id: '408aa004-911d-4fff-af96-69b19da1d0be',
      },
    ],
  },
  {
    fakePromotionId: '838265af-53d8-4f7a-89b9-4b342ef33450',
    relatePromotion: [
      {
        type: 'ParkingPromotion',
        id: 'TEST_ERROR_ID',
      },
    ],
  },
];

const prodFakePromotionQueryList = [
  {
    fakePromotionId: '2e55b7c1-d53c-4820-9af9-cbd597757630',
    relatePromotion: [
      {
        type: 'RefuelingPromotion',
        id: 'eb2bcba6-6459-41df-bfe4-22f30e52f1ce',
      },
      {
        type: 'InvoicePromotion',
        id: '690fd347-8202-4bd9-98cd-7e6aa86326d6',
      },
    ],
  },
  {
    fakePromotionId: 'e836a91a-abef-4adf-805b-1957cc73c345',
    relatePromotion: [
      {
        type: 'RefuelingPromotion',
        id: '1162c400-e6c1-469a-9638-6adf6ebc98d9',
      },
      {
        type: 'InvoicePromotion',
        id: '933b4768-3380-4231-9579-c5c2619be849',
      },
    ],
  },
  {
    fakePromotionId: '9c542fa4-b11c-4dac-8ab4-daa932475e0e',
    relatePromotion: [
      {
        type: 'ParkingPromotion',
        id: '4f4f0b59-d9e0-4f1c-9f2a-0b4c395f7790',
      },
    ],
  },
  {
    fakePromotionId: 'b3944e3d-50e5-4ae6-93b7-86d37437553c',
    relatePromotion: [
      {
        type: 'OnStreetParkingPromotion',
        id: 'a4846361-4f45-43bd-9a08-7a6014c0adfd',
      },
    ],
  },
];

export const fakePromotionQueryList =
  ENV === 'development'
    ? devFakePromotionQueryList
    : prodFakePromotionQueryList;

export const preProcessing = (promotions) => {
  let fakePromotions = [];
  let realPromotions = [];
  let promotionBoards = [];

  promotions.forEach((p) => {
    if (isFromPromotionBoard(p)) {
      promotionBoards.push(p);
    } else {
      if (p.type === 'FakePromotion') {
        fakePromotions.push(p);
      } else {
        realPromotions.push(p);
      }
    }
  });

  // 去除跟 fakepromotion 同名的 promotion
  realPromotions = realPromotions.filter((item) => {
    return !fakePromotions.find((x) => x.name === item.name);
  });

  const availableFakePromotionQueryList = fakePromotionQueryList.filter(
    (item) => fakePromotions.find((x) => x.id === item.fakePromotionId),
  );

  return Promise.all(
    availableFakePromotionQueryList.map(async (fakeItem) => {
      await Promise.all(
        fakeItem.relatePromotion.map(
          async (relateItem) =>
            await repository.fetchPromotionUserUsageStatus(relateItem.id),
        ),
      )
        .then((result) => {
          let userUsageStatus = {};
          result.forEach(({ error, data }) => {
            if (!error) {
              let type = fakeItem.relatePromotion.find(
                (relateItem) => relateItem.id === data.promotionId,
              ).type;
              userUsageStatus[type] =
                data.perMonthUsedCountLimit - data.perMonthUsedCount;
            }
          });

          fakePromotions.find(
            (promotion) => promotion.id === fakeItem.fakePromotionId,
          )['userUsageStatus'] = userUsageStatus;
        })
        .catch((err) => {
          console.log(err);
        });
    }),
  ).then(() => {
    const result = promotionBoards.concat(
      fakePromotions.sort((a, b) => {
        if (b.position < a.position) return 1;
        if (b.position > a.position) return -1;
        return 0;
      }),
      sortingPromotionsByDate(realPromotions),
    );
    return result;
  });
};

export const filtering = ({
  promotions = [],
  filterBy = 'all',
  selectedTag = undefined,
  selectedIds = undefined,
}) => {
  let result = promotions.filter((p) => {
    if (filterBy === 'all') return true;
    if (isFromPromotionBoard(p)) {
      return p.attributes.pageSetting.includes(filterBy);
    } else {
      return p.type === 'FakePromotion'
        ? p.displayPromotionTypes.includes(filterBy)
        : p.type === filterBy;
    }
  });

  if (selectedTag) {
    result = result.filter((p) => p.tags.includes(selectedTag));
  }

  if (selectedIds !== undefined) {
    result = result.filter((d) => selectedIds.includes(d.id));
  }

  return result;
};

const useStore = create((set, get) => ({
  inside: '',
  setInside: (payload) => set({ inside: payload }),
  loading: true,
  setLoading: (state) => set({ loading: state }),
  fetchPromotions: async () => {
    get().setLoading(true);
    const currentDistributor = process.env.NEXT_PUBLIC_DISTRIBUTOR;

    try {
      const promotions = await repository.fetchPromotions({
        distributor: currentDistributor,
      });

      const collections = await repository.fetchPromotionCollections({
        distributor: currentDistributor,
      });

      const rawData = await preProcessing(
        promotions.data.filter((x) => x !== undefined),
      );

      const promotionCollectionData = collections.data.filter(
        (x) => x !== undefined,
      );

      get().setRawData(rawData);
      get().setPromotionCollections(promotionCollectionData);
    } catch (err) {
      console.error(err);
    } finally {
      get().setLoading(false);
    }
  },
  fetchApsPromotions: async () => {
    get().setLoading(true);
    const { error, data } = await repository.fetchPromotions({
      distributor: DISTRIBUTOR.AUTOPASS,
      parkinglotOnline: true,
    });
    if (error) {
      console.log(error);
      return [];
    }

    const promotionData = data.filter((data) => {
      return (
        data !== undefined &&
        !('attribute' in data) &&
        (data.type === 'ParkingPromotion' ||
          (data.type === 'FakePromotion' &&
            data.displayPromotionTypes.includes('ParkingPromotion')))
      );
    });

    const sortedPromotions = sortingPromotionsByDate(promotionData);
    get().setPromotions(sortedPromotions);
    get().setLoading(false);
  },
  filterBy: '',
  setFilterBy: (payload) => set({ filterBy: payload }),
  rawData: [],
  setRawData: (payload) => set({ rawData: payload }),
  setPromotionCollections: (payload) => set({ promotionCollections: payload }),
  promotionCollection: null,
}));

export default useStore;
